import { render, staticRenderFns } from "./SuggestPwaInstall.vue?vue&type=template&id=53c9224a&scoped=true&"
import script from "./SuggestPwaInstall.vue?vue&type=script&lang=ts&"
export * from "./SuggestPwaInstall.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestPwaInstall.vue?vue&type=style&index=0&id=53c9224a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9224a",
  null
  
)

export default component.exports